<footer class="bg-light text-dark py-4">
	<div class="container-lg">
		<div class="row justify-content-center">
			<div class="col-12 text-center col-sm-4 col-md text-md-start">
				<img
					class="w-100"
					src="assets/images/NorthstarMLSFooterLogo.png"
					style="max-width: 210px"
				/>
			</div>
			<div
				class="col-12 text-center col-sm-8 text-sm-right col-md-auto"
				style="font-size: 0.875rem"
			>
				Our Help Desk is ready to assist Monday through Friday from 8:00 AM to 5:00 PM CT.
				<br />Contact us via email at
				<a class="text-nowrap" href="mailto:help@northstarmls.com">help&#64;northstarmls.com</a> or
				by phone at
				<a class="text-nowrap" href="tel:651-251-5456">(651) 251-5456</a>&nbsp;or&nbsp;<a
					class="text-nowrap"
					href="tel:+1-877-251-5455"
					>(877) 251-5455</a
				>&nbsp;(toll-free).<br />
				<span class="small">
					<span class="text-muted mr-1">v.{{ version }} </span>
					<span class="text-muted mr-1">- {{ hostname }}</span>
					<sup> &#169; </sup>
					<span>{{ getFullYear() }}</span> NorthstarMLS. All Rights Reserved.
				</span>
			</div>
		</div>
	</div>
</footer>
